import { Checkbox, CheckboxProps, useMergeRefs } from '@chakra-ui/react';
import { ChangeEvent, forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { SimpleField, SimpleXProps } from './SimpleField';
import { useSimpleFormContext } from './SimpleForm';

type SimpleCheckboxProps = SimpleXProps &
  CheckboxProps & {
    fieldLabel?: string;
  };

export const SimpleCheckbox = forwardRef(
  ({ name, label, fieldLabel = '', ignoreOnBlur = false, variant, size, ...rest }: SimpleCheckboxProps, ref) => {
    const { simpleOnBlur } = useSimpleFormContext();
    const { register, watch } = useFormContext();
    const value = watch(name);

    const formProps = register(name);
    const mergedRef = useMergeRefs(ref, formProps.ref);
    const updateForm = (event: ChangeEvent<HTMLInputElement>) => {
      formProps.onBlur(event);
      if (ignoreOnBlur) return;
      simpleOnBlur?.(event);
    };

    return (
      <SimpleField<CheckboxProps> name={name} label={fieldLabel} size={size} {...rest}>
        <Checkbox variant={variant} {...formProps} ref={mergedRef} isChecked={value} onChange={updateForm} size={size}>
          {label}
        </Checkbox>
      </SimpleField>
    );
  },
);
